import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { logo } from "../../assets";

import { BurgerClose } from "react-burger-icons";

import MobileNavBar from "../landingpage/MobileNavBar";

const Header = () => {
  const [menuShow, setMenuShow] = useState(false);
  const nodeRef = useRef(null);

  const handleMenu = (e) => {
    setMenuShow((prev) => !prev);
  };

  return (
    <>
      <nav className="w-full flex justify-between items-center py-5 sm:px-16 px-6 gap-5">
        <Link to="/" className="">
          <img src={logo} className="w-[160px]" alt="logo" />
        </Link>
        <ul className="list-none md:flex hidden justify-center gap-10 pt-2">
          <li className="font-normal text-[20px] hover:-translate-y-1 hover:transition duration-100">
            <a href="#home">Home</a>
          </li>
          <li className="font-normal text-[20px] hover:-translate-y-1 hover:transition duration-100">
            <a href="#aboutus">About Us</a>
          </li>
          <li className="font-normal text-[20px] hover:-translate-y-1 hover:transition duration-100">
            <a href="#subjects">Topics</a>
          </li>
          <li className="font-normal text-[20px] hover:-translate-y-1 hover:transition duration-100">
            <a href="#contactus">Contact Us</a>
          </li>
        </ul>
        <div className="md:flex hidden justify-end items-center gap-5">
          <Link to="/login">
            <button className="hover:bg-secondary hover:ease-in transition duration-150 hover:text-white font-medium text-[16px] rounded-md border-secondary text-secondary border py-[6px] px-6">
              Login/Register
            </button>
          </Link>
          {/* <button className="hover:bg-secondary hover:text-white font-bold text-[16px] rounded-md border-secondary border-2 h-[36px] w-[100px]">
          Register
        </button> */}
        </div>
        {/* TODO Mobile Responsive Menu */}
        <div className="md:hidden flex">
          <button
            type="button"
            onClick={handleMenu}
            style={{
              width: "50px",
              height: "50px",
              display: "grid",
              placeItems: "center",
            }}
          >
            <BurgerClose isClosed={menuShow} />
          </button>
        </div>
      </nav>
      <div
        className="md:hidden block mobile-nav"
        style={{
          height: !menuShow ? 0 : nodeRef.current?.clientHeight,
        }}
      >
        <div ref={nodeRef}>
          <MobileNavBar />
        </div>
      </div>
    </>
  );
};

export default Header;
